//libs
import clsx from "clsx";
import { useEffect, useState } from "react";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
//components
import TenderItem from "./components/TenderItem";
//hooks
import {
  useFetchOpportunitiesCount,
  useFetchTenders,
} from "hooks/api/useTenders";
//icons
import { InformationCircleIcon } from "@heroicons/react/24/solid";
import { useLocation, useNavigate } from "react-router-dom";

const bannerImage = require("../../../images/banner.png");

export default function TenderList() {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const typeFromUrl = parseInt(searchParams.get("type") || "1");
  const dateFromUrl = searchParams.get("date") || "all";
  // const [keyword, setKeyword] = useState("");
  // const [status, setStatus] = useState("open");
  const [type, setType] = useState(typeFromUrl);
  const [date, setDate] = useState(dateFromUrl);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const { data } = useFetchTenders({
    // keyword,
    // status,
    date,
    type,
    page,
    limit: pageSize,
  });
  const tenders = data?.data;
  const totalTenders = data?.meta?.total || 0;

  const { data: totalCount } = useFetchOpportunitiesCount();

  const tenderTypeOptions = [
    {
      label: "Tenders",
      value: 1,
      count: totalCount?.totalTendersCount?.all,
    },
    {
      label: "Quotations",
      value: 2,
      count: totalCount?.totalQuotationsCount?.all,
    },
  ];

  const countWithDateFilter =
    type === 1
      ? totalCount?.totalTendersCount
      : totalCount?.totalQuotationsCount;

  const tabs = [
    { name: "All", value: "all", count: countWithDateFilter?.all },
    { name: "Today", value: "today", count: countWithDateFilter?.today },
    {
      name: "This Week",
      value: "this_week",
      count: countWithDateFilter?.this_week,
    },
    {
      name: "This Month",
      value: "this_month",
      count: countWithDateFilter?.this_month,
    },
    {
      name: "Past 7 Days",
      value: "last_seven_days",
      count: countWithDateFilter?.last_seven_days,
    },
  ];

  useEffect(() => {
    const params = new URLSearchParams();
    params.set("type", type.toString());
    params.set("date", date);
    navigate(`/opportunities?${params.toString()}`, { replace: true });
  }, [type, date, navigate]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleTypeChange = (newType) => {
    setType(newType);
    setPage(1);
  };

  const handleDateChange = (newDate) => {
    setDate(newDate);
    setPage(1);
  };

  return (
    <>
      <div className="relative h-80">
        <img
          src={bannerImage}
          alt="banner"
          className="absolute inset-0 w-full h-full object-cover object-center brightness-50"
        />
        <div className="relative h-full flex flex-col items-center justify-center text-center text-white">
          <p className="text-lg text-orange-200">browse your</p>
          <h2 className="text-4xl font-bold mt-2">Opportunities in Asia</h2>
          <div className="mt-4 w-full max-w-xl px-4">
            <div className="relative">
              <input
                type="text"
                placeholder="Enter Keywords"
                className="w-full px-4 py-2 rounded-lg bg-white text-gray-800"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="mx-auto w-full max-w-6xl relative px-4 sm:px-6 lg:px-8">
        <div className="-mt-8 bg-white rounded-lg shadow-sm border flex gap-4 px-4 py-2">
          <InformationCircleIcon className="size-6 text-blue-600" />
          <div>
            <p className="font-bold">
              We got {totalCount?.totalOpportunitiesCount} opportunities
            </p>
            <p className="text-gray-600 text-sm">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid
              pariatur, ipsum dolor.
            </p>
          </div>
        </div>
        <div className="max-w-4xl mx-auto mt-8">
          <div className="border font-bold h-10 mt-4 rounded-lg flex bg-gray-50">
            {tenderTypeOptions.map((option) => (
              <button
                key={option.value}
                className={`flex items-center justify-center gap-1 grow ${
                  option.value === type
                    ? "ring-1 rounded-lg ring-gray-200 bg-white"
                    : ""
                }`}
                onClick={() => handleTypeChange(option.value)}
              >
                {option.label}
                <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                  {option.count}
                </span>
              </button>
            ))}
          </div>
          <div className="border-b border-gray-200">
            <nav
              aria-label="Tabs"
              className="-mb-px flex space-x-8 justify-center"
            >
              {tabs.map((tab) => (
                <button
                  key={tab.name}
                  aria-current={tab.current ? "page" : undefined}
                  onClick={() => handleDateChange(tab.value)}
                  className={clsx(
                    tab.value === date
                      ? "border-blue-500 text-blue-600"
                      : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700",
                    "gap-1 flex border-b-2 px-1 py-3 text-sm font-medium grow justify-center"
                  )}
                >
                  {tab.name}
                  <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                    {tab.count}
                  </span>
                  {/* {tab.value === date && (
                    <span className="inline-flex items-center rounded-full bg-blue-50 px-2 py-1 text-xs font-medium text-blue-600 ring-1 ring-inset ring-blue-500/30">
                      {tenders.length}
                    </span>
                  )} */}
                </button>
              ))}
            </nav>
          </div>
          <ul className="grid grid-cols-1 gap-x-6 gap-y-6 py-4 xl:gap-x-8">
            {tenders?.length > 0 ? (
              <>
                {tenders?.map((tender) => (
                  <TenderItem key={tender.id} tender={tender} type={type} />
                ))}
              </>
            ) : (
              <div className="rounded-md bg-white  p-4 border border-gray-100">
                <p className="text-sm text-gray-500 text-center">
                  No {type === 1 ? "Tenders" : "Quotations"} found.
                </p>
              </div>
            )}
          </ul>
          {totalTenders > pageSize && (
            <div className="flex justify-center py-4">
              <Pagination
                current={page}
                total={totalTenders}
                pageSize={pageSize}
                onChange={handlePageChange}
                className="pagination"
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
